import { translate } from '@jsverse/transloco';

import { FieldService } from 'app/providers/storage-api/field.service';

export class ScatterPlotUtils {
  public static getAxisName(axis: string, isTitle: boolean = false) {
    switch (axis) {
      case 'sentiment':
        if (isTitle) {
          return translate('widgets.datatable.sentiment');
        } else {
          return translate('widgets.datatable.avg-sentiment');
        }
      case 'volume':
        if (isTitle) {
          return translate('widgets.datatable.volume');
        } else {
          return translate('widgets.datatable.number-of-documents');
        }
      case 'frequency':
        return translate('widgets.datatable.frequency');
      case 'impact_positive':
        return translate('widgets.datatable.positive-impact');
      case 'impact_negative':
        return translate('widgets.datatable.negative-impact');
      default:
        return FieldService.getFieldLongName(axis);
    }
  }

  public static getDatatableColumnHeader(axis: string, interval?: 'previous' | 'current') {
    let header = ScatterPlotUtils.getAxisName(axis);

    if (interval) {
      header += ` (${translate('widgets.datatable.' + interval)})`;
    }

    return header;
  }
}
